import gql from 'graphql-tag';
import eventFragment from '../fragments/event';

const CREATE_EVENT = gql`
  mutation CreateEvent($data: CreateEventInput!) {
    createEvent(data: $data) {
      ...eventDetails
      type
      eventGroup {
        id
        name
      }
    }
  }
  ${eventFragment.FRAGMENT_EVENT}
`;

const UPDATE_EVENT_BY_ID = gql`
  mutation UpdateEventById($data: UpdateEventInput, $id: ID!) {
    updateEventById(data: $data, id: $id) {
      ...eventDetails
      type
      protocol {
        id
        name
      }
      eventGroup {
        id
        name
      }
      custom {
        id
        technicalDescription
        type
        priority
        eventGroupId
        color
        isMonitorable
      }
    }
  }
  ${eventFragment.FRAGMENT_EVENT}
`;

const DELETE_EVENT_BY_ID = gql`
  mutation DeleteEventById($id: ID!) {
    deleteEventById(id: $id) {
      id
      code
    }
  }
`;

export default {
  CREATE_EVENT,
  UPDATE_EVENT_BY_ID,
  DELETE_EVENT_BY_ID,
};
